import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ForeignAddressFormModel } from './foreign-address-form.model';
import { AdresZagraniczny } from '../../../../models/adres';
import { SharedValidators } from '../../../../validators/shared-validators';

export class ForeignAddressFormBuilder {
  public static createFormGroup(
    address?: AdresZagraniczny,
  ): FormGroup<ForeignAddressFormModel> {
    return new FormGroup<ForeignAddressFormModel>({
      id: new FormControl(address?.id || null),
      gminaDzielnica: new FormControl(address?.gminaDzielnica || null, [
        Validators.required,
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      miejscowosc: new FormControl(address?.miejscowosc || null, [
        Validators.required,
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      ulica: new FormControl(address?.ulica || null, [
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      nrDomu: new FormControl(address?.nrDomu || null, [
        SharedValidators.doNotBeginWithWhitespace(),
        Validators.maxLength(10),
      ]),
      nrLokalu: new FormControl(address?.nrLokalu || null, [
        SharedValidators.doNotBeginWithWhitespace(),
        Validators.maxLength(10),
      ]),
      kodPocztowyZagraniczny: new FormControl(
        address?.kodPocztowyZagraniczny || null,
        [Validators.required, SharedValidators.doNotBeginWithWhitespace()],
      ),
      panstwo: new FormControl(address?.panstwo || null, [Validators.required]),
    });
  }
}
